// extracted by mini-css-extract-plugin
module.exports = {"container":"PageHeader_container__1zNE0","docs_button":"PageHeader_docs_button__60Ovw","icon":"PageHeader_icon__3uZqO","title":"PageHeader_title__3dny8"};